module.exports = __webpack_public_path__ + "img/bk2.a8bcb8df.png";